<template>
  <div id="opdashboard">
    <Fieldset class="p-shadow-8">
      <template #legend>
        <Dropdown
          class="p-shadow-8"
          v-model="selectedCountries"
          :options="countries"
          optionLabel="name"
          placeholder="Select a Bumper#"
          :filter="true"
          filterPlaceholder="Find Bumper #"
        />
      </template>
      <br />
      <label
        >Select multiple dates you are available to deliver the equipment
      </label>
      <br />

      <div>
        <i class="pi pi-calendar-plus" />
        <Calendar
          v-model="value"
          selectionMode="multiple"
          :showButtonBar="true"
          class="p-shadow-8"
        />
      </div>

      <br /><br />

      <div class="p-field p-grid">
        <label for="firstname" class="p-col-fixed" style="width: 100px"
          >Driver's Firstname</label
        >
        <div class="p-col">
          <InputText
            id="firstname"
            type="text"
            placeholder="default this user"
          />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="lastname" class="p-col-fixed" style="width: 100px"
          >Driver's Lastname</label
        >
        <div class="p-col">
          <InputText
            id="lastname"
            type="text"
            placeholder="default this user"
          />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="location" class="p-col-fixed" style="width: 130px"
          >Reason for Visit</label
        >
        <div class="p-col">
          <InputText id="reason" type="text" />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="location" class="p-col-fixed" style="width: 130px"
          >Driver's Phone#</label
        >
        <div class="p-col">
          <InputText
            id="location"
            type="text"
            placeholder="default this user"
          />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="location" class="p-col-fixed" style="width: 130px"
          >Driver's Email</label
        >
        <div class="p-col">
          <InputText
            id="location"
            type="text"
            placeholder="default this user"
          />
        </div>
      </div>

      <Rating v-model="rating" :stars="10" />
    </Fieldset>
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Fieldset from "primevue/fieldset";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Rating from "primevue/rating";
import { fb_auth } from "../firebase";
export default {
  name: "OpDashboard",
  components: {
    Dropdown,
    Fieldset,
    InputText,
    Calendar,
    Rating,
  },
  data() {
    return {
      value: null,
      selectedCountries: null,
      selectedTechStatus: null,
      countries: [
        { name: "A5", code: "AU" },
        { name: "A6", code: "BR" },
        { name: "A7", code: "CN" },
        { name: "A310", code: "EG" },
        { name: "A311", code: "FR" },
        { name: "A312", code: "DE" },
        { name: "A313", code: "IN" },
        { name: "A314", code: "JP" },
        { name: "A210", code: "ES" },
        { name: "A211", code: "US" },
      ],
      techStatus: [
        { code: "Diagonal - /" },
        { code: "Deadlined - X" },
        { code: "Safety - E" },
        { code: "Unknown - U" },
        { code: "No Fault Found" },
      ],
    };
  },
  methods: {
    logoutUser() {
      fb_auth
        .signOut()
        .then(() => {
          //sign-out successful.
          this.$router.push({ path: "/" });
        })
        .catch(function (error) {
          //an error happened
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  color: #999999;
}
</style>